<div id="modal-container" bg-close="false" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-padding-remove uk-margin-auto-vertical">
        <div #modalContainer></div>
    </div>
</div>